import React, { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import MainState from './context/MainState';
import { Provider } from 'react-redux';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <StrictMode>
    <MainState>
      <Suspense>
        <BrowserRouter>
        <Provider store={store}>
          <App />
          </Provider>
        </BrowserRouter>
      </Suspense>
    </MainState>
  // </StrictMode>
);
